import SonicTerm, { SonicTermData } from "./SonicTerm";

export interface SonicOfferUserMetaData {
  name: string;
  email?: string;
  full_name?: string;
  roles?: Array<string>;
  school?: SonicTermData;
}

export default class SonicOfferUserMeta implements SonicOfferUserMetaData {
  name: string;
  email?: string;
  full_name?: string;
  roles?: Array<string>;
  school?: SonicTermData;

  constructor(
    name: string,
    email?: string,
    full_name?: string,
    roles?: Array<string>,
    school?: SonicTermData
  ) {
    this.name = name;
    this.email = email;
    this.full_name = full_name;
    this.roles = roles;
    this.school = school && SonicTerm.parseFromAPIResponse(school);
  }

  static serializeOfferUserMeta = (offerUserMeta: SonicOfferUserMetaData) => {
    return {
      ...offerUserMeta,
      school: offerUserMeta.school && { ...offerUserMeta.school },
    };
  };
}
